import { Icon } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import BlurInput from "../../../../../components/BlurInput";
import useCostTypeOptions from "../../../../costs/hooks/useCostTypeOptions";
import Form from "../../../../forms/components/Form/Form";
import useEmployeeOptions from "../../../../users/hooks/useEmployeeOptions";

import usePriceUnitOptions from "../../../hooks/usePriceUnitOptions";

import VatSelect from "../../VatSelect/VatSelect";

const parts = ["user", "subcontractor"];

export default function usePricesColumns({ onRemove }) {
	const { t } = useTranslation();

	const unitOptions = usePriceUnitOptions();
	const employeeOptions = useEmployeeOptions();
	const costTypeOptions = useCostTypeOptions(parts);

	return [
		{
			id: "type",
			Header: t("type", "Type"),
			Cell: ({ index }) => (
				<Form.Select
					name={`prices.${index}.type`}
					search
					upward
					fluid
					options={costTypeOptions}
					placeholder={t("chooseType", "Select type")}
				/>
			),
		},
		{
			id: "name",
			Header: t("name", "Name"),
			Cell: ({ index }) => (
				<Form.Field name={`prices.${index}.name`}>
					<BlurInput placeholder={t("namePrice", "Name price variant")} />
				</Form.Field>
			),
		},
		{
			id: "price",
			Header: t("price", "Price"),
			Cell: ({ index }) => (
				<Form.NumberInput
					style={{ width: 90 }}
					name={`prices.${index}.price`}
					rules={{
						min: 0,
						required: true,
						valueAsNumber: true,
					}}
				/>
			),
		},
		{
			id: "unit",
			Header: t("unit", "Unit"),
			Cell: ({ index }) => <Form.Select name={`prices.${index}.unit`} upward options={unitOptions} />,
		},
		{
			id: "employee",
			Header: t("employee", "Employee"),
			Cell: ({ index }) => (
				<Form.Select
					name={`prices.${index}.employee`}
					options={employeeOptions}
					rules={{ required: false }}
					fluid
					style={{ width: 150 }}
					upward
				/>
			),
		},
		{
			id: "vat",
			Header: t("VAT", "VAT"),
			Cell: ({ index }) => (
				<Form.Field name={`prices.${index}.vat`}>
					<VatSelect upward style={{ width: 80 }} />
				</Form.Field>
			),
		},
		{
			id: "remove",
			Cell: ({ index }) => (
				<Icon name="trash alternate outline" style={{ cursor: "pointer" }} onClick={() => onRemove(index)} />
			),
		},
	];
}
